import React from "react";
import { FiBookOpen, FiGlobe, FiCommand, FiCpu } from "react-icons/fi";
import logo from "../../assets/logo.svg";
import "../../styles/AboutSection.css";

export default function PartnershipsSection() {
  const universityLogos = [
    { src: "https://images.seeklogo.com/logo-png/31/2/universite-ibn-zohr-agadir-maroc-logo-png_seeklogo-315828.png", label: "IAMAR" },
  ];

  const organizationLogos = [
    { src: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Unitar_vertical_logo_blue-png.png", label: "IAMAR" },
  ];

  const institutionLogos = [
    { src: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Unitar_vertical_logo_blue-png.png", label: "IAMAR" },
  ];

  const priveLogos = [
    { src: "https://upload.wikimedia.org/wikipedia/commons/e/ec/Royal_Moroccan_gendarmery.png", label: "Gendarmerie Royale" },
    { src: "https://upload.wikimedia.org/wikipedia/commons/e/ef/Emblem_of_the_Moroccan_DGSN.svg", label: "DGSN" },
    { src: "https://upload.wikimedia.org/wikipedia/commons/f/f6/Forces_Auxiliaires.png", label: "Forces Auxiliaires" },
    { src: "https://upload.wikimedia.org/wikipedia/commons/f/f5/Logo_de_la_Protection_Civile_Marocaine.svg", label: "Protection Civile" },
  ];

  return (
    <section className="about-sub-section partnerships-section" id="partenariats">
      <div className="section-header-v2">
        <span className="accent-line"></span>
        <h2>ÉCOSYSTÈME COLLABORATIF</h2>
      </div>

      <div className="collaborative-ecosystem-grid">
        <div className="ecosystem-card card-academic">
          <div className="card-top">
            <FiBookOpen className="card-icon" />
            <span className="card-tag">Recherche</span>
          </div>
          <div className="card-body">
            <h4>Universités</h4>
            <p>Collaboration scientifique, co-publications et programmes doctoraux.</p>
          </div>
          <div className="card-logos">
            <div className={`logos-grid ${universityLogos.length > 3 ? 'is-carousel' : ''}`}>
              <div className="logos-track">
                {universityLogos.map((logo, idx) => (
                  <div key={idx} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
                {universityLogos.length > 3 && universityLogos.map((logo, idx) => (
                  <div key={`dup-${idx}`} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="ecosystem-card card-global">
          <div className="card-top">
            <FiGlobe className="card-icon" />
            <span className="card-tag">Global</span>
          </div>
          <div className="card-body">
            <h4>Organisations</h4>
            <p>Programmes de formation et projets avec UNITAR et centres spécialisés.</p>
          </div>
          <div className="card-logos">
            <div className={`logos-grid ${organizationLogos.length > 3 ? 'is-carousel' : ''}`}>
              <div className="logos-track">
                {organizationLogos.map((logo, idx) => (
                  <div key={idx} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
                {organizationLogos.length > 3 && organizationLogos.map((logo, idx) => (
                  <div key={`dup-${idx}`} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="ecosystem-card card-gov">
          <div className="card-top">
            <FiCommand className="card-icon" />
            <span className="card-tag">Stratégie</span>
          </div>
          <div className="card-body">
            <h4>Institutions</h4>
            <p>Accompagnement stratégique et appui à la transformation des systèmes.</p>
          </div>
          <div className="card-logos">
            <div className={`logos-grid ${institutionLogos.length > 3 ? 'is-carousel' : ''}`}>
              <div className="logos-track">
                {institutionLogos.map((logo, idx) => (
                  <div key={idx} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
                {institutionLogos.length > 3 && institutionLogos.map((logo, idx) => (
                  <div key={`dup-${idx}`} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="ecosystem-card card-tech">
          <div className="card-top">
            <FiCpu className="card-icon" />
            <span className="card-tag">Innovation</span>
          </div>
          <div className="card-body">
            <h4>Secteur Privé</h4>
            <p>Innovation, solutions digitales et services de cybersécurité.</p>
          </div>
          <div className="card-logos">
            <div className={`logos-grid ${priveLogos.length > 3 ? 'is-carousel' : ''}`}>
              <div className="logos-track">
                {priveLogos.map((logo, idx) => (
                  <div key={idx} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
                {priveLogos.length > 3 && priveLogos.map((logo, idx) => (
                  <div key={`dup-${idx}`} className="logo-item">
                    <img src={logo.src} alt={logo.label} className="partner-logo" title={logo.label} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
